module.exports = __webpack_public_path__ + "static/img/hero4_info.0d59829.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/hero4_info.png
// module id = VeMY
// module chunks = 1